module.exports = __webpack_public_path__ + "static/img/thumb-insects.80bb83a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-insects.png
// module id = 91
// module chunks = 0